import { ChatMessageDocument } from '@models/chat';
import { sanitizeChatHtml } from '@util/index';

interface MessageAutoProps {
  message: ChatMessageDocument;
  onRightClick?: (ev: React.MouseEvent) => void;
}

export default function MessageAuto({
  message,
  onRightClick,
}: MessageAutoProps) {
  return (
    <div className="my-12 flex w-full items-center justify-center">
      {message.content_html ? (
        <p
          className="message-content max-w-[80vw] truncate whitespace-pre-line text-center text-[1.6rem] font-medium text-zinc-500"
          onContextMenu={onRightClick}
          // the auto messages will have 2 lines max.
          dangerouslySetInnerHTML={{
            __html: sanitizeChatHtml(message.content_html).replace(
              /<a class="router-link" data-link="(\/(?!\/)[^"]*)">/g,
              '<a href="$1" class="text-brand-primary hover:underline">'
            ),
          }}
        />
      ) : (
        <p
          className="message-content max-w-[80vw] truncate whitespace-pre-line text-center text-[1.6rem] font-medium text-zinc-500"
          onContextMenu={onRightClick}
        >
          {message.content}
        </p>
      )}
    </div>
  );
}
